import home from './src/home.vue'
import RegionManagerView from './src/RegionManagerView.vue' //区域管理

let views = {
    home,
    RegionManagerView
};

export default views;